export const environment = {
  production: true,
  backofficeUrl: "http://41.65.131.30:9090",
  globalDataApi: "http://164.160.104.123:3030",
  feedUrl: "http://41.65.131.15:8090",
  recaptcha: {
    siteKey: "6LePCWEfAAAAAIbSbj1pSyTZp_UDG5ItAS4ReI24",
  },
  version: "V. 20260519 B.61.0.0",
};
